<template>
    <v-row>
        <!-- GROUP BY -->
        <v-col cols="12">
            <select-option-students @change="currentGroupBy = $event" no-list />
        </v-col>
        <!-- STUDENT FILTER -->
        <v-col cols="12" v-if="currentGroupBy === 'student'">
            <kimsa-combobox :label="$tc('student.student', 1)" :placeholder="$t('common.select_placeholder')" outlined
                dense solo :items="students" @change="setCurrentStudent" :value="currentStudent" placeholder-class
                item-value="objectID" searchable />
        </v-col>
        <!-- GROUP FILTER -->
        <v-col cols="12" v-if="currentGroupBy === 'group'">
            <kimsa-combobox :label="$t('common.group')" :placeholder="$t('common.select_placeholder')" outlined dense
                solo :items="groups" @change="setCurrentGroup" :value="currentGroup" placeholder-class
                item-value="objectID" searchable />
        </v-col>
        <!-- TEAM FILTER -->
        <template v-if="currentGroupBy === 'team'">
            <v-col cols="12" md="6">
                <kimsa-combobox :label="$t('common.team')" :placeholder="$t('common.select_placeholder')" outlined dense
                    solo :items="teams" @change="setCurrentTeam" :value="currentTeam" placeholder-class
                    item-value="objectID" searchable />
            </v-col>
            <v-col cols="12" md="6">
                <kimsa-combobox :label="$t('common.group')" :placeholder="$t('common.select_placeholder')" outlined
                    dense solo :items="teamGroups" @change="setCurrentTeamGroup" :readonly="!currentTeam"
                    :value="currentTeamGroup" placeholder-class item-value="objectID" searchable />
            </v-col>
        </template>
    </v-row>
</template>

<script>
import SelectOptionStudents from "@/components/coach/SelectOptionStudents";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import { Client, UserIndex } from "@/utils/Algolia";
import { mapActions, mapState } from "vuex";

export default {
    name: "SetSelectionRoutine",
    components: { SelectOptionStudents, KimsaCombobox },
    props: {
        coachId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            currentGroupBy: null,
            students: [],
            currentStudent: null,
            currentGroup: null,
            currentTeam: null,
            currentTeamGroup: null,
        }
    },
    computed: {
        ...mapState(['groups', 'teams']),
        teamGroups(vm = this) {
            return vm.currentTeam?.groups.map(group => {
                return {
                    teamId: vm.currentTeam.id,
                    ...group,
                    id: group.id,
                }
            }) || []
        },
        currentSelection(vm = this) {
            switch (vm.currentGroupBy) {
                case "student":
                    return vm.currentStudent
                case "group":
                    return vm.currentGroup
                case "team":
                    return vm.currentTeamGroup
                default:
                    return null
            }
        },
        collectionName(vm = this) {
            return vm.currentGroupBy === 'student' ? 'assignedRoutines' : 'groupAssignedRoutines'
        },
    },
    async mounted() {
        const vm = this
        await vm.loadStudents()
        if (vm.groups.length === 0) await vm.bindGroups(vm.coachId)
        if (vm.teams.length === 0) await vm.bindTeams(vm.coachId)
    },
    methods: {
        ...mapActions(['bindGroups', 'bindTeams']),
        async loadStudents() {
            const vm = this
            let filter = `studentSubscription.coachId: ${vm.coachId} AND studentSubscription.paused != 1`
            await Client.clearCache()
            await UserIndex.search('', {
                filters: filter,
                hitsPerPage: 10000,
            })
                .then(({ hits }) => {
                    vm.students = hits
                })
                .catch(err => {
                    console.log(err);
                });
        },
        setCurrentStudent(student) {
            const vm = this
            if (student?.name) {
                vm.currentStudent = student
            } else if (student) {
                let foundStudent = vm.students?.find(st => st.name.toLowerCase() === student.toLowerCase()) || null
                foundStudent ? vm.currentStudent = foundStudent : vm.currentStudent = null
            } else {
                vm.currentStudent = null
            }
        },
        setCurrentGroup(group) {
            const vm = this
            if (group?.name) {
                vm.currentGroup = group
            } else if (group) {
                let foundGroup = vm.groups?.find(gr => gr.name.toLowerCase() === group.toLowerCase()) || null
                foundGroup ? vm.currentGroup = foundGroup : vm.currentGroup = null
            } else {
                vm.currentGroup = null
            }
        },
        setCurrentTeam(team) {
            const vm = this
            if (team?.name) {
                vm.currentTeam = team
            } else if (team) {
                let foundTeam = vm.teams?.find(tm => tm.name.toLowerCase() === team.toLowerCase()) || null
                foundTeam ? vm.currentTeam = foundTeam : vm.currentTeam = null
            } else {
                vm.currentTeam = null
            }
        },
        setCurrentTeamGroup(teamGroup) {
            const vm = this
            if (teamGroup?.name) {
                vm.currentTeamGroup = teamGroup
            } else if (teamGroup) {
                let foundTeamGroup = vm.teamGroups?.find(tmg => tmg.name.toLowerCase() === teamGroup.toLowerCase()) || null
                foundTeamGroup ? vm.currentTeamGroup = foundTeamGroup : vm.currentTeamGroup = null
            } else {
                vm.currentTeamGroup = null
            }
        },
        reset() {
            const vm = this;
            vm.currentStudent = null
            vm.currentGroup = null
            vm.currentTeam = null
            vm.currentTeamGroup = null
        }
    },
    watch: {
        currentGroupBy(val) {
            if (val === 'student') {
                this.currentGroup = null
                this.currentTeam = null
                this.currentTeamGroup = null
            }
            if (val === 'group') {
                this.currentStudent = null
                this.currentTeam = null
                this.currentTeamGroup = null
            }
            if (val === 'team') {
                this.currentStudent = null
                this.currentGroup = null
            }
        },
        currentSelection(val) {
            this.$emit('change', val)
        },
        collectionName(val) {
            this.$emit('collection', val)
        }
    }
}
</script>

<style scoped></style>